<template>
  <div class="controller-awards">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tên" prop="name">
          <a-input v-model="form.name" placeholder="Tên" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Nội dung" prop="content">
          <a-textarea :rows="5" v-model="form.content" placeholder="Nội dung" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Vị trí" prop="position">
          <a-input v-model="form.position" placeholder="Vị trí" />
        </a-form-model-item>
        <a-form-model-item class="mb-30" label="Avatar" :colon="false">
          <input
            type="file"
            accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
            @change="onAvatarChange"
          />
        </a-form-model-item>
        <img
          v-show="avatarUrl"
          id="preview-avatar"
          :src="avatarUrl"
          class="preview-avatar"
        />
        <a-form-model-item>
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import {
  fetchById,
  updatePeopleInCharge,
  createPeopleInCharge,
} from "@/services/landing-page/about-us";
export default {
  name: "ControllerPeopleInCharge",
  data() {
    return {
      callingAPI: false,
      form: {
        name: "",
        description: "",
        content: "",
        position: "",
        active: 1,
        type: 3,
        post_type: 2,
        image: null,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        content: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        position: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
      },

      avatarUrl: "",
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {
    async loadData() {
      try {
        const response = await fetchById(this.$route.params.id);
        this.form.name = response.data.name;
        this.form.content = response.data.content;
        this.form.position = response.data.position;
        this.avatarUrl = response.data.about_us_file.length
          ? `${process.env.VUE_APP_LANDING_PAGE_BACKEND_URL}/${response.data.about_us_file[0].url_file}`
          : "";
        this.form.active = response.data.active;
      } catch (error) {}
    },

    onAvatarChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.form.image = file;
        this.avatarUrl = URL.createObjectURL(file);
      }
    },

    async handleSubmit() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              if (!this.avatarUrl) {
                this.$message.error("Vui lòng upload ảnh đại diện!");
                return;
              }
              this.callingAPI = true;
              const formData = new FormData();
              formData.append("name", this.form.name);
              formData.append("description", this.form.description);
              formData.append("position", this.form.position);
              formData.append("content", this.form.content);
              formData.append("active", this.form.active);
              formData.append("type", this.form.type);
              formData.append("post_type", this.form.post_type);

              if (this.form.image) {
                formData.append("image[]", this.form.image);
              }
              let message;

              if (this.$route.params.id) {
                formData.append("_method", "PUT");
                await updatePeopleInCharge(this.$route.params.id, formData);
              } else {
                await createPeopleInCharge(formData);
              }
              this.callingAPI = false;
              message = this.$route.params.id
                ? "Cập nhật thành công"
                : "Thêm mới thành công";
              this.$notification.success({
                message: "Thành công",
                description: message,
              });
              this.$router.push({ name: "ManagePeopleInCharge" });
            } catch (error) {
              console.log(error);
              let message = this.$route.params.id
                ? "Cập nhật thất bại"
                : "Thêm mới thất bại";
              this.$notification.error({
                message: "Thất bại",
                description: message,
              });
            }
          }
        });
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>